import type { WashedLocale } from '@washed/i18n';

const FR_TO_EN: Record<string, string> = {
  '/': '/en',
  '/tarifs': '/en/tarifs',
  '/comment-ca-marche': '/en/comment-ca-marche',
  '/devenir-laveuse': '/en/devenir-laveuse',
  '/a-propos': '/en/a-propos',
  '/faq': '/en/faq',
  '/zones': '/en/zones',
  '/contact': '/en/contact',
  '/laveuse-a-domicile-lome': '/en/washerwoman-service-lome',
  '/lessive-a-domicile-lome': '/en/in-home-laundry-lome',
  '/prix-laveuse-lome': '/en/laundry-prices-lome',
  '/trouver-laveuse-fiable-lome': '/en/reliable-washerwoman-lome',
  '/pressing-ou-laveuse': '/en/dry-cleaning-vs-home-laundry-lome',
  '/abonnement-lessive-lome': '/en/laundry-subscription-lome',
  '/lessive-famille-lome': '/en/family-laundry-service-lome',
  '/pas-le-temps-lessive-lome': '/en/laundry-for-busy-people-lome',
  '/qui-peut-laver-mon-linge-lome': '/en/someone-to-wash-my-clothes-lome',
  '/laveuse-ou-aide-menagere': '/en/washerwoman-vs-housekeeper-lome',
  '/payer-lessive-proche-togo': '/en/pay-for-family-laundry-togo',
  '/travail-laveuse-lome': '/en/washerwoman-jobs-lome',
  '/lessive-etudiant-lome': '/en/student-laundry-lome',
  '/lessive-jeune-professionnel-lome': '/en/laundry-young-professionals-lome',
  '/etude-lessive-lome': '/en/lome-laundry-research',
};

const EN_TO_FR = Object.fromEntries(Object.entries(FR_TO_EN).map(([fr, en]) => [en, fr])) as Record<
  string,
  string
>;

function normalize(pathname: string): string {
  if (pathname === '/') return '/';
  return pathname.replace(/\/+$/u, '') || '/';
}

export function localeCounterpartPath(pathname: string, locale: WashedLocale): string | null {
  const path = normalize(pathname);
  return locale === 'fr' ? (FR_TO_EN[path] ?? null) : (EN_TO_FR[path] ?? null);
}
